import { render } from "./CurrencyInput.vue?vue&type=template&id=400edf54&ts=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=ts"
export * from "./CurrencyInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__